import React, { FC, ReactNode } from 'react';
import { PORTAL_POSITION } from '../../../../../../models/User';
import IconAlignLeft from '../../../../../../components/icons/icon-align-left/icon-align-left';
import IconAlignRight from '../../../../../../components/icons/icon-align-right/icon-align-right';
import IconAlignCenter from '../../../../../../components/icons/icon-align-center/icon-align-center';
import './portal-position-select.scss';

interface IPortalPositionOption {
	icon: ReactNode,
	value: PORTAL_POSITION
}

interface Props {
	value: PORTAL_POSITION,
	onChange: (value: PORTAL_POSITION) => void
}

const PortalPositionSelect:FC<Props> = ({ value, onChange }) => {

	const portalPositionOptions: IPortalPositionOption[] = [
		{ icon: <IconAlignLeft/>, value: PORTAL_POSITION.LEFT },
		{ icon: <IconAlignCenter/>, value: PORTAL_POSITION.CENTER },
		{ icon: <IconAlignRight/>, value: PORTAL_POSITION.RIGHT },
	]

	return (
		<div className="portal-position-select">
			{
				portalPositionOptions.map((option) => (
					<div
						key={option.value}
						className={`portal-position-option ${value === option.value ? 'selected' : ''}`}
						onClick={() => onChange(option.value)}
					>
						{option.icon}
					</div>
				))
			}
		</div>
	);
};


export default PortalPositionSelect;
